/* tslint:disable */
/* eslint-disable */
/**
 * OnData.Users
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AdminDashboardDto
 */
export interface AdminDashboardDto {
    /**
     * 
     * @type {number}
     * @memberof AdminDashboardDto
     */
    'totalCustomerCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDashboardDto
     */
    'registerCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminDashboardDto
     */
    'registerCountPrev'?: number;
}
/**
 * 
 * @export
 * @interface AdminInvitationResponseDto
 */
export interface AdminInvitationResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminInvitationResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminInvitationResponseDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminInvitationResponseDto
     */
    'planId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminInvitationResponseDto
     */
    'organizationName'?: string | null;
}
/**
 * 
 * @export
 * @interface ChangePasswordInput
 */
export interface ChangePasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    'originalPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordInput
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface ChangePhoneInput
 */
export interface ChangePhoneInput {
    /**
     * 
     * @type {string}
     * @memberof ChangePhoneInput
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface ChangePhoneResponseDto
 */
export interface ChangePhoneResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ChangePhoneResponseDto
     */
    'verificationCodeId'?: number;
}
/**
 * 
 * @export
 * @interface ClientInfoEditDto
 */
export interface ClientInfoEditDto {
    /**
     * 
     * @type {string}
     * @memberof ClientInfoEditDto
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientInfoEditDto
     */
    'remark'?: string | null;
}
/**
 * 
 * @export
 * @interface ClientManageDto
 */
export interface ClientManageDto {
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {ClientType}
     * @memberof ClientManageDto
     */
    'clientType'?: ClientType;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'softwareVersion'?: string | null;
    /**
     * 
     * @type {ClientStatus}
     * @memberof ClientManageDto
     */
    'status'?: ClientStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ClientManageDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'osInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'ipAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'remark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'registerAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'registerByUser'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r1UserFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r1UserLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r1Username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'reviewedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'reviewedByUser'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r2UserFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r2UserLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r2Username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'revokedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'revokedByUser'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r3UserFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r3UserLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r3Username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'suspendedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientManageDto
     */
    'suspendedByUser'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r4UserFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r4UserLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientManageDto
     */
    'r4Username'?: string | null;
}
/**
 * 
 * @export
 * @interface ClientManageDtoPaginationResult
 */
export interface ClientManageDtoPaginationResult {
    /**
     * 
     * @type {Array<ClientManageDto>}
     * @memberof ClientManageDtoPaginationResult
     */
    'items'?: Array<ClientManageDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ClientManageDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ClientRegistrationRequest
 */
export interface ClientRegistrationRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientRegistrationRequest
     */
    'client_name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientRegistrationRequest
     */
    'token_endpoint_auth_method': string;
    /**
     * 
     * @type {JsonWebKeySet}
     * @memberof ClientRegistrationRequest
     */
    'jwks': JsonWebKeySet;
    /**
     * 
     * @type {string}
     * @memberof ClientRegistrationRequest
     */
    'software_id': string;
    /**
     * 
     * @type {string}
     * @memberof ClientRegistrationRequest
     */
    'software_version': string;
    /**
     * 
     * @type {string}
     * @memberof ClientRegistrationRequest
     */
    'os_info'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientRegistrationRequest
     */
    'register_code'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ClientStatus {
    PendingApproval = 0,
    Rejected = 1,
    Enabled = 2,
    Suspend = 3,
    Revoked = 100
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ClientType {
    ClassicalInternal = 0,
    DataDriver = 1,
    EncryptionTool = 2,
    ShareSecretDataDriver = 3,
    ShareSecretEncryptionTool = 4,
    SecureFileApp = 5
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CloudProvider {
    Azure = 1,
    AzureUSGovernment = 2,
    Aws = 3,
    Gcp = 4
}

/**
 * 
 * @export
 * @interface CloudSubscriptionInput
 */
export interface CloudSubscriptionInput {
    /**
     * 
     * @type {number}
     * @memberof CloudSubscriptionInput
     */
    'organizationId': number;
    /**
     * 
     * @type {CloudProvider}
     * @memberof CloudSubscriptionInput
     */
    'cloudProvider': CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionInput
     */
    'resourceGroupName': string;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionInput
     */
    'region': string;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionInput
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionInput
     */
    'clientCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionInput
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionInput
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionInput
     */
    'subscriptionId': string;
}
/**
 * 
 * @export
 * @interface CloudSubscriptionResponseDto
 */
export interface CloudSubscriptionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof CloudSubscriptionResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {CloudProvider}
     * @memberof CloudSubscriptionResponseDto
     */
    'cloudProvider'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'typeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'resourceGroupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'clientCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'subscriptionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'storageAccountName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'keyVaultName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CloudSubscriptionResponseDto
     */
    'modifiedTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CloudSubscriptionResponseDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CloudSubscriptionResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface ConfirmChangePhoneInput
 */
export interface ConfirmChangePhoneInput {
    /**
     * 
     * @type {number}
     * @memberof ConfirmChangePhoneInput
     */
    'verificatoinCodeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfirmChangePhoneInput
     */
    'code'?: string | null;
}
/**
 * 
 * @export
 * @interface ConfirmUserInvitationInput
 */
export interface ConfirmUserInvitationInput {
    /**
     * 
     * @type {string}
     * @memberof ConfirmUserInvitationInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmUserInvitationInput
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmUserInvitationInput
     */
    'confirmPassword'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateRegisterCodeInput
 */
export interface CreateRegisterCodeInput {
    /**
     * 
     * @type {number}
     * @memberof CreateRegisterCodeInput
     */
    'validInHours': number;
    /**
     * 
     * @type {number}
     * @memberof CreateRegisterCodeInput
     */
    'maxAllowedUsage'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateShareSecretClientInput
 */
export interface CreateShareSecretClientInput {
    /**
     * 
     * @type {string}
     * @memberof CreateShareSecretClientInput
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareSecretClientInput
     */
    'remark'?: string | null;
    /**
     * 
     * @type {ClientType}
     * @memberof CreateShareSecretClientInput
     */
    'clientType': ClientType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DeviceFlowClient {
    PSUpload = 1,
    PSDownload = 2,
    DataDriver = 3,
    EncryptionTool = 4,
    EncryptionToolV2 = 5
}

/**
 * 
 * @export
 * @interface DeviceFlowRequestInfo
 */
export interface DeviceFlowRequestInfo {
    /**
     * 
     * @type {DeviceFlowClient}
     * @memberof DeviceFlowRequestInfo
     */
    'deviceFlowClient'?: DeviceFlowClient;
    /**
     * 
     * @type {string}
     * @memberof DeviceFlowRequestInfo
     */
    'creationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceFlowRequestInfo
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface EmailInput
 */
export interface EmailInput {
    /**
     * 
     * @type {string}
     * @memberof EmailInput
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface EmailTargetDto
 */
export interface EmailTargetDto {
    /**
     * 
     * @type {string}
     * @memberof EmailTargetDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailTargetDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailTargetDto
     */
    'lastName'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EmailType {
    Unknown = 0,
    Register = 1,
    AdminInvite = 2,
    UserInvite = 3,
    ChangeEmail = 4,
    ResetPassword = 5,
    GenericAlert = 6,
    MFA = 7,
    BackupAlert = 8,
    BackupNotReceivedAlert = 9,
    ValidationAlert = 10,
    SameDomainRegisterNotify = 11,
    OnDataAdminNotifyNewRegister = 1001
}

/**
 * 
 * @export
 * @interface EmailValidateInput
 */
export interface EmailValidateInput {
    /**
     * 
     * @type {string}
     * @memberof EmailValidateInput
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface FeatureResponseDto
 */
export interface FeatureResponseDto {
    /**
     * 
     * @type {OnDataFeature}
     * @memberof FeatureResponseDto
     */
    'featureId'?: OnDataFeature;
    /**
     * 
     * @type {string}
     * @memberof FeatureResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface InitPasswordConfirmInput
 */
export interface InitPasswordConfirmInput {
    /**
     * 
     * @type {string}
     * @memberof InitPasswordConfirmInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof InitPasswordConfirmInput
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof InitPasswordConfirmInput
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface InternalListOrganizationAdminsInput
 */
export interface InternalListOrganizationAdminsInput {
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalListOrganizationAdminsInput
     */
    'organizationIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface InternalListUsersInput
 */
export interface InternalListUsersInput {
    /**
     * 
     * @type {number}
     * @memberof InternalListUsersInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalListUsersInput
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface InviteUserInput
 */
export interface InviteUserInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteUserInput
     */
    'emails'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof InviteUserInput
     */
    'roleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof InviteUserInput
     */
    'defaultRoleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface JsonWebKey
 */
export interface JsonWebKey {
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'alg'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'crv'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'dp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'dq'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'e'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'k'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonWebKey
     */
    'key_ops'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'kid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'kty'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'n'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonWebKey
     */
    'oth'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'p'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'q'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'qi'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'use'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonWebKey
     */
    'x5c'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x5t'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x5t#S256'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x5u'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'y'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JsonWebKey
     */
    'keySize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JsonWebKey
     */
    'hasPrivateKey'?: boolean;
}
/**
 * 
 * @export
 * @interface JsonWebKeySet
 */
export interface JsonWebKeySet {
    /**
     * 
     * @type {Array<JsonWebKey>}
     * @memberof JsonWebKeySet
     */
    'keys'?: Array<JsonWebKey> | null;
}
/**
 * 
 * @export
 * @interface LoginInput
 */
export interface LoginInput {
    /**
     * 
     * @type {string}
     * @memberof LoginInput
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LoginInput
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof LoginInput
     */
    'clientId'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginResponseDto
 */
export interface LoginResponseDto {
    /**
     * 
     * @type {number}
     * @memberof LoginResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {MfaWay}
     * @memberof LoginResponseDto
     */
    'mfaWay'?: MfaWay;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseDto
     */
    'phoneTail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LoginResponseDto
     */
    'vCodeId'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum MfaWay {
    Email = 0,
    Phone = 1
}

/**
 * 
 * @export
 * @interface NotificationAssignDto
 */
export interface NotificationAssignDto {
    /**
     * 
     * @type {EmailType}
     * @memberof NotificationAssignDto
     */
    'notificationType'?: EmailType;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationAssignDto
     */
    'roles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationAssignDto
     */
    'customRoles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationAssignDto
     */
    'users'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface NotificationAssignRolesInput
 */
export interface NotificationAssignRolesInput {
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationAssignRolesInput
     */
    'roles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof NotificationAssignRolesInput
     */
    'customRoles'?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum OnDataFeature {
    OnDataDriver = 1,
    OnDataSecureFile = 2
}

/**
 * 
 * @export
 * @interface OptionResponseDto
 */
export interface OptionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OptionResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OptionResponseDto
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OptionResponseDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OptionResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OptionResponseDto
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface OrganizationProfileInput
 */
export interface OrganizationProfileInput {
    /**
     * 
     * @type {number}
     * @memberof OrganizationProfileInput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileInput
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProfileInput
     */
    'planId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileInput
     */
    'streetAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileInput
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileInput
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileInput
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileInput
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileInput
     */
    'zipCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileInput
     */
    'invoiceEmail'?: string | null;
}
/**
 * 
 * @export
 * @interface OrganizationProfileResponseDto
 */
export interface OrganizationProfileResponseDto {
    /**
     * 
     * @type {number}
     * @memberof OrganizationProfileResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'orgCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'domain'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProfileResponseDto
     */
    'planId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'streetAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'zipCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationProfileResponseDto
     */
    'invoiceEmail'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationProfileResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface OrganizationProfileResponseDtoPaginationResult
 */
export interface OrganizationProfileResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<OrganizationProfileResponseDto>}
     * @memberof OrganizationProfileResponseDtoPaginationResult
     */
    'items'?: Array<OrganizationProfileResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationProfileResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface PermissionResponseDto
 */
export interface PermissionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PermissionResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponseDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any | any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface RegisterCodeResponse
 */
export interface RegisterCodeResponse {
    /**
     * 
     * @type {number}
     * @memberof RegisterCodeResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RegisterCodeResponse
     */
    'codeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterCodeResponse
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RegisterCodeResponse
     */
    'creatorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterCodeResponse
     */
    'creatorUserame'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterCodeResponse
     */
    'creatorFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterCodeResponse
     */
    'creatorLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterCodeResponse
     */
    'createTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCodeResponse
     */
    'expiration'?: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterCodeResponse
     */
    'maxAllowedUsage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RegisterCodeResponse
     */
    'actualUsage'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterCodeResponse
     */
    'voided'?: boolean;
}
/**
 * 
 * @export
 * @interface RegisterCodeResponsePaginationResult
 */
export interface RegisterCodeResponsePaginationResult {
    /**
     * 
     * @type {Array<RegisterCodeResponse>}
     * @memberof RegisterCodeResponsePaginationResult
     */
    'items'?: Array<RegisterCodeResponse> | null;
    /**
     * 
     * @type {number}
     * @memberof RegisterCodeResponsePaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface RegisterInput
 */
export interface RegisterInput {
    /**
     * 
     * @type {string}
     * @memberof RegisterInput
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterInput
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterInput
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterInput
     */
    'recaptchaResponse': string;
}
/**
 * 
 * @export
 * @interface RegisterResponseDto
 */
export interface RegisterResponseDto {
    /**
     * 
     * @type {number}
     * @memberof RegisterResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterResponseDto
     */
    'isConfirmed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {RegisterStatus}
     * @memberof RegisterResponseDto
     */
    'status'?: RegisterStatus;
}
/**
 * 
 * @export
 * @interface RegisterResponseDtoPaginationResult
 */
export interface RegisterResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<RegisterResponseDto>}
     * @memberof RegisterResponseDtoPaginationResult
     */
    'items'?: Array<RegisterResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof RegisterResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum RegisterResult {
    Success = 0,
    DomainExists = 1
}

/**
 * 
 * @export
 * @interface RegisterResultResponseDto
 */
export interface RegisterResultResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterResultResponseDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {RegisterResult}
     * @memberof RegisterResultResponseDto
     */
    'result'?: RegisterResult;
    /**
     * 
     * @type {string}
     * @memberof RegisterResultResponseDto
     */
    'resultText'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum RegisterStatus {
    PendingReview = 0,
    Accepted = 1,
    Rejected = 2
}

/**
 * 
 * @export
 * @interface ResetPasswordInput
 */
export interface ResetPasswordInput {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordInput
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordInput
     */
    'recaptchaResponse': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordResponseDto
 */
export interface ResetPasswordResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ResetPasswordResponseDto
     */
    'vCodeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResetPasswordResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResetPasswordResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordResponseDto
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface RoleInput
 */
export interface RoleInput {
    /**
     * 
     * @type {number}
     * @memberof RoleInput
     */
    'roleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RoleInput
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof RoleInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof RoleInput
     */
    'permissionIds': Array<number>;
}
/**
 * 
 * @export
 * @interface RoleResponseDto
 */
export interface RoleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof RoleResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleResponseDto
     */
    'roleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponseDto
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponseDto
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponseDto
     */
    'isAdmin'?: boolean;
    /**
     * 
     * @type {Array<PermissionResponseDto>}
     * @memberof RoleResponseDto
     */
    'permissions'?: Array<PermissionResponseDto> | null;
}
/**
 * 
 * @export
 * @interface ShareSecretResponse
 */
export interface ShareSecretResponse {
    /**
     * 
     * @type {string}
     * @memberof ShareSecretResponse
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShareSecretResponse
     */
    'clientSecret'?: string | null;
}
/**
 * 
 * @export
 * @interface SsoConfigResponseDto
 */
export interface SsoConfigResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SsoConfigResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SsoConfigResponseDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {SsoProtocol}
     * @memberof SsoConfigResponseDto
     */
    'protocol'?: SsoProtocol;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'samlLoginUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'samlLogoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'samlEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'samlCertificate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'samlAssertionConsumerServiceUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'samlSpIssuer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'oidcDomain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'oidcClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'oidcClientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'oidcLogoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoConfigResponseDto
     */
    'oidcRedirectUrl'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum SsoProtocol {
    SAML = 0,
    OIDC = 1
}

/**
 * 
 * @export
 * @interface SsoRequestInput
 */
export interface SsoRequestInput {
    /**
     * 
     * @type {string}
     * @memberof SsoRequestInput
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SsoRequestInput
     */
    'clientId'?: string | null;
}
/**
 * 
 * @export
 * @interface StorageFirewallIpInput
 */
export interface StorageFirewallIpInput {
    /**
     * 
     * @type {string}
     * @memberof StorageFirewallIpInput
     */
    'ip': string;
    /**
     * 
     * @type {boolean}
     * @memberof StorageFirewallIpInput
     */
    'isCidr'?: boolean;
}
/**
 * 
 * @export
 * @interface TestResultResponseDto
 */
export interface TestResultResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof TestResultResponseDto
     */
    'isSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TestResultResponseDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateClientVersionInput
 */
export interface UpdateClientVersionInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientVersionInput
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientVersionInput
     */
    'version'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateUserInput
 */
export interface UpdateUserInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateUserInput
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserInput
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateUserInput
     */
    'roleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateUserInput
     */
    'defaultRoleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateUserInput
     */
    'dataAccessRoleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface UserInvitationResponseDto
 */
export interface UserInvitationResponseDto {
    /**
     * 
     * @type {number}
     * @memberof UserInvitationResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserInvitationResponseDto
     */
    'userInvitationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserInvitationResponseDto
     */
    'inviteeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserInvitationResponseDto
     */
    'inviteeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInvitationResponseDto
     */
    'inviteeEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInvitationResponseDto
     */
    'roleIds'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInvitationResponseDto
     */
    'defaultRoleIds'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInvitationResponseDto
     */
    'rolesText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInvitationResponseDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInvitationResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserInvitationResponseDto
     */
    'isExpired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserInvitationResponseDto
     */
    'isSsoEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface UserInvitationSearchCriterias
 */
export interface UserInvitationSearchCriterias {
    /**
     * 
     * @type {number}
     * @memberof UserInvitationSearchCriterias
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserInvitationSearchCriterias
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserInvitationSearchCriterias
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserInvitationSearchCriterias
     */
    'customRoleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserInvitationSearchCriterias
     */
    'defaultRoleIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface UserInvitationsResponseDto
 */
export interface UserInvitationsResponseDto {
    /**
     * 
     * @type {Array<UserInvitationResponseDto>}
     * @memberof UserInvitationsResponseDto
     */
    'items'?: Array<UserInvitationResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UserInvitationsResponseDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface UserManageDto
 */
export interface UserManageDto {
    /**
     * 
     * @type {number}
     * @memberof UserManageDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserManageDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserManageDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserManageDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserManageDto
     */
    'lastLoginTime'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserManageDto
     */
    'status'?: UserStatus;
    /**
     * 
     * @type {string}
     * @memberof UserManageDto
     */
    'rolesText'?: string | null;
}
/**
 * 
 * @export
 * @interface UserOptionResponseDto
 */
export interface UserOptionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof UserOptionResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserOptionResponseDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOptionResponseDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserOptionResponseDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserOptionResponseDto
     */
    'status'?: UserStatus;
}
/**
 * 
 * @export
 * @interface UserOptionsResponseDto
 */
export interface UserOptionsResponseDto {
    /**
     * 
     * @type {Array<UserOptionResponseDto>}
     * @memberof UserOptionsResponseDto
     */
    'items'?: Array<UserOptionResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UserOptionsResponseDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface UserResponseDto
 */
export interface UserResponseDto {
    /**
     * 
     * @type {number}
     * @memberof UserResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'orgCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'defaultRegion'?: string | null;
    /**
     * 
     * @type {CloudProvider}
     * @memberof UserResponseDto
     */
    'defaultProvider'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'avatarUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {MfaWay}
     * @memberof UserResponseDto
     */
    'mfaWay'?: MfaWay;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'lastLoginTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'language'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'timeZoneName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserResponseDto
     */
    'timeZoneOffset'?: number;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserResponseDto
     */
    'status'?: UserStatus;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'statusText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'rolesText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserResponseDto
     */
    'dataAccessRoleList'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserResponseDto
     */
    'dataAccessRoleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserResponseDto
     */
    'permissions'?: Array<string> | null;
    /**
     * 
     * @type {Array<RoleResponseDto>}
     * @memberof UserResponseDto
     */
    'roles'?: Array<RoleResponseDto> | null;
    /**
     * 
     * @type {Array<FeatureResponseDto>}
     * @memberof UserResponseDto
     */
    'features'?: Array<FeatureResponseDto> | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'singleLogoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDto
     */
    'isSsoEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDto
     */
    'isAdmin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDto
     */
    'isUserProfileSet'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDto
     */
    'isOrganizationProfileSet'?: boolean;
}
/**
 * 
 * @export
 * @interface UserSearchCriterias
 */
export interface UserSearchCriterias {
    /**
     * 
     * @type {number}
     * @memberof UserSearchCriterias
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserSearchCriterias
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserSearchCriterias
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserSearchCriterias
     */
    'customRoleIds'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserSearchCriterias
     */
    'defaultRoleIds'?: Array<number> | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof UserSearchCriterias
     */
    'status'?: UserStatus;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum UserStatus {
    Active = 0,
    Inactive = 1
}

/**
 * 
 * @export
 * @interface UsersResponseDto
 */
export interface UsersResponseDto {
    /**
     * 
     * @type {Array<UserManageDto>}
     * @memberof UsersResponseDto
     */
    'items'?: Array<UserManageDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UsersResponseDto
     */
    'total'?: number;
}

/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdApprovePut: async (clientId: string, clientInfoEditDto?: ClientInfoEditDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdApprovePut', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/approve`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientInfoEditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdKeyRefreshPut: async (clientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdKeyRefreshPut', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/key/refresh`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdKeyResetShareSecretPost: async (clientId: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdKeyResetShareSecretPost', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/key/resetShareSecret`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdPut: async (clientId: string, clientInfoEditDto?: ClientInfoEditDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdPut', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientInfoEditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdRejectPut: async (clientId: string, clientInfoEditDto?: ClientInfoEditDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdRejectPut', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/reject`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientInfoEditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdResumePut: async (clientId: string, clientInfoEditDto?: ClientInfoEditDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdResumePut', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/resume`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientInfoEditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdRevokePut: async (clientId: string, clientInfoEditDto?: ClientInfoEditDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdRevokePut', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/revoke`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientInfoEditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSuspendPut: async (clientId: string, clientInfoEditDto?: ClientInfoEditDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiClientsClientIdSuspendPut', 'clientId', clientId)
            const localVarPath = `/api/clients/{clientId}/suspend`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientInfoEditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateShareSecretClientInput} [createShareSecretClientInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsCreateWithShareSecretPost: async (createShareSecretClientInput?: CreateShareSecretClientInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/create/withShareSecret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShareSecretClientInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDriversEncryptToolsGet: async (status?: ClientStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/drivers-encrypt-tools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} codeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterCodesCodeIdDeclareVoidPut: async (codeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('apiClientsRegisterCodesCodeIdDeclareVoidPut', 'codeId', codeId)
            const localVarPath = `/api/clients/register-codes/{codeId}/declare-void`
                .replace(`{${"codeId"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterCodesGet: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/register-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRegisterCodeInput} [createRegisterCodeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterCodesPost: async (createRegisterCodeInput?: CreateRegisterCodeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/register-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRegisterCodeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientRegistrationRequest} [clientRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterPost: async (clientRegistrationRequest?: ClientRegistrationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientRegistrationRequest} [clientRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterPublicSecureFilePost: async (clientRegistrationRequest?: ClientRegistrationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/register-public/secure-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientStatus} [status] 
         * @param {string} [term] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortField] 
         * @param {boolean} [sortAscending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSecurefilesGet: async (status?: ClientStatus, term?: string, page?: number, limit?: number, sortField?: string, sortAscending?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/clients/securefiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortAscending !== undefined) {
                localVarQueryParameter['sortAscending'] = sortAscending;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdApprovePut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdApprovePut(clientId, clientInfoEditDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdKeyRefreshPut(clientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdKeyRefreshPut(clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdKeyResetShareSecretPost(clientId: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareSecretResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdKeyResetShareSecretPost(clientId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdPut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdPut(clientId, clientInfoEditDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdRejectPut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdRejectPut(clientId, clientInfoEditDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdResumePut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdResumePut(clientId, clientInfoEditDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdRevokePut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdRevokePut(clientId, clientInfoEditDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsClientIdSuspendPut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsClientIdSuspendPut(clientId, clientInfoEditDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateShareSecretClientInput} [createShareSecretClientInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsCreateWithShareSecretPost(createShareSecretClientInput?: CreateShareSecretClientInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareSecretResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsCreateWithShareSecretPost(createShareSecretClientInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClientStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsDriversEncryptToolsGet(status?: ClientStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientManageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsDriversEncryptToolsGet(status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} codeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsRegisterCodesCodeIdDeclareVoidPut(codeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsRegisterCodesCodeIdDeclareVoidPut(codeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsRegisterCodesGet(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterCodeResponsePaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsRegisterCodesGet(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRegisterCodeInput} [createRegisterCodeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsRegisterCodesPost(createRegisterCodeInput?: CreateRegisterCodeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsRegisterCodesPost(createRegisterCodeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClientRegistrationRequest} [clientRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsRegisterPost(clientRegistrationRequest?: ClientRegistrationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsRegisterPost(clientRegistrationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClientRegistrationRequest} [clientRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsRegisterPublicSecureFilePost(clientRegistrationRequest?: ClientRegistrationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsRegisterPublicSecureFilePost(clientRegistrationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClientStatus} [status] 
         * @param {string} [term] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortField] 
         * @param {boolean} [sortAscending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiClientsSecurefilesGet(status?: ClientStatus, term?: string, page?: number, limit?: number, sortField?: string, sortAscending?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientManageDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiClientsSecurefilesGet(status, term, page, limit, sortField, sortAscending, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientApiFp(configuration)
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdApprovePut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsClientIdApprovePut(clientId, clientInfoEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdKeyRefreshPut(clientId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsClientIdKeyRefreshPut(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdKeyResetShareSecretPost(clientId: string, body?: string, options?: any): AxiosPromise<ShareSecretResponse> {
            return localVarFp.apiClientsClientIdKeyResetShareSecretPost(clientId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdPut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsClientIdPut(clientId, clientInfoEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdRejectPut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsClientIdRejectPut(clientId, clientInfoEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdResumePut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsClientIdResumePut(clientId, clientInfoEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdRevokePut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsClientIdRevokePut(clientId, clientInfoEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {ClientInfoEditDto} [clientInfoEditDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsClientIdSuspendPut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsClientIdSuspendPut(clientId, clientInfoEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateShareSecretClientInput} [createShareSecretClientInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsCreateWithShareSecretPost(createShareSecretClientInput?: CreateShareSecretClientInput, options?: any): AxiosPromise<ShareSecretResponse> {
            return localVarFp.apiClientsCreateWithShareSecretPost(createShareSecretClientInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsDriversEncryptToolsGet(status?: ClientStatus, options?: any): AxiosPromise<Array<ClientManageDto>> {
            return localVarFp.apiClientsDriversEncryptToolsGet(status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} codeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterCodesCodeIdDeclareVoidPut(codeId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsRegisterCodesCodeIdDeclareVoidPut(codeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterCodesGet(page?: number, limit?: number, options?: any): AxiosPromise<RegisterCodeResponsePaginationResult> {
            return localVarFp.apiClientsRegisterCodesGet(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRegisterCodeInput} [createRegisterCodeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterCodesPost(createRegisterCodeInput?: CreateRegisterCodeInput, options?: any): AxiosPromise<RegisterCodeResponse> {
            return localVarFp.apiClientsRegisterCodesPost(createRegisterCodeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientRegistrationRequest} [clientRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterPost(clientRegistrationRequest?: ClientRegistrationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsRegisterPost(clientRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientRegistrationRequest} [clientRegistrationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsRegisterPublicSecureFilePost(clientRegistrationRequest?: ClientRegistrationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiClientsRegisterPublicSecureFilePost(clientRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientStatus} [status] 
         * @param {string} [term] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sortField] 
         * @param {boolean} [sortAscending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiClientsSecurefilesGet(status?: ClientStatus, term?: string, page?: number, limit?: number, sortField?: string, sortAscending?: boolean, options?: any): AxiosPromise<ClientManageDtoPaginationResult> {
            return localVarFp.apiClientsSecurefilesGet(status, term, page, limit, sortField, sortAscending, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * 
     * @param {string} clientId 
     * @param {ClientInfoEditDto} [clientInfoEditDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsClientIdApprovePut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsClientIdApprovePut(clientId, clientInfoEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsClientIdKeyRefreshPut(clientId: string, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsClientIdKeyRefreshPut(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsClientIdKeyResetShareSecretPost(clientId: string, body?: string, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsClientIdKeyResetShareSecretPost(clientId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {ClientInfoEditDto} [clientInfoEditDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsClientIdPut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsClientIdPut(clientId, clientInfoEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {ClientInfoEditDto} [clientInfoEditDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsClientIdRejectPut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsClientIdRejectPut(clientId, clientInfoEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {ClientInfoEditDto} [clientInfoEditDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsClientIdResumePut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsClientIdResumePut(clientId, clientInfoEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {ClientInfoEditDto} [clientInfoEditDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsClientIdRevokePut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsClientIdRevokePut(clientId, clientInfoEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {ClientInfoEditDto} [clientInfoEditDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsClientIdSuspendPut(clientId: string, clientInfoEditDto?: ClientInfoEditDto, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsClientIdSuspendPut(clientId, clientInfoEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateShareSecretClientInput} [createShareSecretClientInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsCreateWithShareSecretPost(createShareSecretClientInput?: CreateShareSecretClientInput, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsCreateWithShareSecretPost(createShareSecretClientInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsDriversEncryptToolsGet(status?: ClientStatus, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsDriversEncryptToolsGet(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} codeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsRegisterCodesCodeIdDeclareVoidPut(codeId: number, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsRegisterCodesCodeIdDeclareVoidPut(codeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsRegisterCodesGet(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsRegisterCodesGet(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRegisterCodeInput} [createRegisterCodeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsRegisterCodesPost(createRegisterCodeInput?: CreateRegisterCodeInput, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsRegisterCodesPost(createRegisterCodeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientRegistrationRequest} [clientRegistrationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsRegisterPost(clientRegistrationRequest?: ClientRegistrationRequest, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsRegisterPost(clientRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientRegistrationRequest} [clientRegistrationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsRegisterPublicSecureFilePost(clientRegistrationRequest?: ClientRegistrationRequest, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsRegisterPublicSecureFilePost(clientRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientStatus} [status] 
     * @param {string} [term] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [sortField] 
     * @param {boolean} [sortAscending] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public apiClientsSecurefilesGet(status?: ClientStatus, term?: string, page?: number, limit?: number, sortField?: string, sortAscending?: boolean, options?: AxiosRequestConfig) {
        return ClientApiFp(this.configuration).apiClientsSecurefilesGet(status, term, page, limit, sortField, sortAscending, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CloudSubscriptionsApi - axios parameter creator
 * @export
 */
export const CloudSubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [tenantId] 
         * @param {CloudProvider} [cloudProvider] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsAzureconsentGet: async (tenantId?: string, cloudProvider?: CloudProvider, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cloudsubscriptions/azureconsent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (cloudProvider !== undefined) {
                localVarQueryParameter['cloudProvider'] = cloudProvider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsDisablePut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cloudsubscriptions/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cloudsubscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CloudSubscriptionInput} [cloudSubscriptionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsPost: async (cloudSubscriptionInput?: CloudSubscriptionInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cloudsubscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloudSubscriptionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CloudSubscriptionInput} [cloudSubscriptionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsTestazurecloudPost: async (cloudSubscriptionInput?: CloudSubscriptionInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cloudsubscriptions/testazurecloud`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloudSubscriptionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CloudSubscriptionsApi - functional programming interface
 * @export
 */
export const CloudSubscriptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CloudSubscriptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [tenantId] 
         * @param {CloudProvider} [cloudProvider] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCloudsubscriptionsAzureconsentGet(tenantId?: string, cloudProvider?: CloudProvider, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCloudsubscriptionsAzureconsentGet(tenantId, cloudProvider, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCloudsubscriptionsDisablePut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCloudsubscriptionsDisablePut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCloudsubscriptionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloudSubscriptionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCloudsubscriptionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CloudSubscriptionInput} [cloudSubscriptionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCloudsubscriptionsPost(cloudSubscriptionInput?: CloudSubscriptionInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCloudsubscriptionsPost(cloudSubscriptionInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CloudSubscriptionInput} [cloudSubscriptionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCloudsubscriptionsTestazurecloudPost(cloudSubscriptionInput?: CloudSubscriptionInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCloudsubscriptionsTestazurecloudPost(cloudSubscriptionInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CloudSubscriptionsApi - factory interface
 * @export
 */
export const CloudSubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CloudSubscriptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [tenantId] 
         * @param {CloudProvider} [cloudProvider] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsAzureconsentGet(tenantId?: string, cloudProvider?: CloudProvider, options?: any): AxiosPromise<string> {
            return localVarFp.apiCloudsubscriptionsAzureconsentGet(tenantId, cloudProvider, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsDisablePut(options?: any): AxiosPromise<void> {
            return localVarFp.apiCloudsubscriptionsDisablePut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsGet(options?: any): AxiosPromise<CloudSubscriptionResponseDto> {
            return localVarFp.apiCloudsubscriptionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CloudSubscriptionInput} [cloudSubscriptionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsPost(cloudSubscriptionInput?: CloudSubscriptionInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiCloudsubscriptionsPost(cloudSubscriptionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CloudSubscriptionInput} [cloudSubscriptionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCloudsubscriptionsTestazurecloudPost(cloudSubscriptionInput?: CloudSubscriptionInput, options?: any): AxiosPromise<TestResultResponseDto> {
            return localVarFp.apiCloudsubscriptionsTestazurecloudPost(cloudSubscriptionInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CloudSubscriptionsApi - object-oriented interface
 * @export
 * @class CloudSubscriptionsApi
 * @extends {BaseAPI}
 */
export class CloudSubscriptionsApi extends BaseAPI {
    /**
     * 
     * @param {string} [tenantId] 
     * @param {CloudProvider} [cloudProvider] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudSubscriptionsApi
     */
    public apiCloudsubscriptionsAzureconsentGet(tenantId?: string, cloudProvider?: CloudProvider, options?: AxiosRequestConfig) {
        return CloudSubscriptionsApiFp(this.configuration).apiCloudsubscriptionsAzureconsentGet(tenantId, cloudProvider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudSubscriptionsApi
     */
    public apiCloudsubscriptionsDisablePut(options?: AxiosRequestConfig) {
        return CloudSubscriptionsApiFp(this.configuration).apiCloudsubscriptionsDisablePut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudSubscriptionsApi
     */
    public apiCloudsubscriptionsGet(options?: AxiosRequestConfig) {
        return CloudSubscriptionsApiFp(this.configuration).apiCloudsubscriptionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CloudSubscriptionInput} [cloudSubscriptionInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudSubscriptionsApi
     */
    public apiCloudsubscriptionsPost(cloudSubscriptionInput?: CloudSubscriptionInput, options?: AxiosRequestConfig) {
        return CloudSubscriptionsApiFp(this.configuration).apiCloudsubscriptionsPost(cloudSubscriptionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CloudSubscriptionInput} [cloudSubscriptionInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudSubscriptionsApi
     */
    public apiCloudsubscriptionsTestazurecloudPost(cloudSubscriptionInput?: CloudSubscriptionInput, options?: AxiosRequestConfig) {
        return CloudSubscriptionsApiFp(this.configuration).apiCloudsubscriptionsTestazurecloudPost(cloudSubscriptionInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DeviceApi - axios parameter creator
 * @export
 */
export const DeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [userCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeviceConsentGet: async (userCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/device/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userCode !== undefined) {
                localVarQueryParameter['userCode'] = userCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [userCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeviceConsentPost: async (userCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/device/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userCode !== undefined) {
                localVarQueryParameter['userCode'] = userCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [usercode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeviceVerifyUsercodePost: async (usercode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/device/verify-usercode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (usercode !== undefined) {
                localVarQueryParameter['usercode'] = usercode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceApi - functional programming interface
 * @export
 */
export const DeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [userCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeviceConsentGet(userCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceFlowRequestInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeviceConsentGet(userCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [userCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeviceConsentPost(userCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeviceConsentPost(userCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [usercode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeviceVerifyUsercodePost(usercode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeviceVerifyUsercodePost(usercode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeviceApi - factory interface
 * @export
 */
export const DeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [userCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeviceConsentGet(userCode?: string, options?: any): AxiosPromise<DeviceFlowRequestInfo> {
            return localVarFp.apiDeviceConsentGet(userCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [userCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeviceConsentPost(userCode?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDeviceConsentPost(userCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [usercode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeviceVerifyUsercodePost(usercode?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDeviceVerifyUsercodePost(usercode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceApi - object-oriented interface
 * @export
 * @class DeviceApi
 * @extends {BaseAPI}
 */
export class DeviceApi extends BaseAPI {
    /**
     * 
     * @param {string} [userCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public apiDeviceConsentGet(userCode?: string, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiDeviceConsentGet(userCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [userCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public apiDeviceConsentPost(userCode?: string, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiDeviceConsentPost(userCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [usercode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public apiDeviceVerifyUsercodePost(usercode?: string, options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).apiDeviceVerifyUsercodePost(usercode, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationAssignApi - axios parameter creator
 * @export
 */
export const NotificationAssignApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotiAssignGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/noti-assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailType} notificationType 
         * @param {NotificationAssignRolesInput} [notificationAssignRolesInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotiAssignNotificationTypeRolesPut: async (notificationType: EmailType, notificationAssignRolesInput?: NotificationAssignRolesInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationType' is not null or undefined
            assertParamExists('apiNotiAssignNotificationTypeRolesPut', 'notificationType', notificationType)
            const localVarPath = `/api/noti-assign/{notificationType}/roles`
                .replace(`{${"notificationType"}}`, encodeURIComponent(String(notificationType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationAssignRolesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailType} notificationType 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotiAssignNotificationTypeUsersPut: async (notificationType: EmailType, requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationType' is not null or undefined
            assertParamExists('apiNotiAssignNotificationTypeUsersPut', 'notificationType', notificationType)
            const localVarPath = `/api/noti-assign/{notificationType}/users`
                .replace(`{${"notificationType"}}`, encodeURIComponent(String(notificationType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationAssignApi - functional programming interface
 * @export
 */
export const NotificationAssignApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationAssignApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotiAssignGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationAssignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotiAssignGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailType} notificationType 
         * @param {NotificationAssignRolesInput} [notificationAssignRolesInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotiAssignNotificationTypeRolesPut(notificationType: EmailType, notificationAssignRolesInput?: NotificationAssignRolesInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotiAssignNotificationTypeRolesPut(notificationType, notificationAssignRolesInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailType} notificationType 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotiAssignNotificationTypeUsersPut(notificationType: EmailType, requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotiAssignNotificationTypeUsersPut(notificationType, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationAssignApi - factory interface
 * @export
 */
export const NotificationAssignApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationAssignApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotiAssignGet(options?: any): AxiosPromise<Array<NotificationAssignDto>> {
            return localVarFp.apiNotiAssignGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailType} notificationType 
         * @param {NotificationAssignRolesInput} [notificationAssignRolesInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotiAssignNotificationTypeRolesPut(notificationType: EmailType, notificationAssignRolesInput?: NotificationAssignRolesInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiNotiAssignNotificationTypeRolesPut(notificationType, notificationAssignRolesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailType} notificationType 
         * @param {Array<number>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotiAssignNotificationTypeUsersPut(notificationType: EmailType, requestBody?: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.apiNotiAssignNotificationTypeUsersPut(notificationType, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationAssignApi - object-oriented interface
 * @export
 * @class NotificationAssignApi
 * @extends {BaseAPI}
 */
export class NotificationAssignApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationAssignApi
     */
    public apiNotiAssignGet(options?: AxiosRequestConfig) {
        return NotificationAssignApiFp(this.configuration).apiNotiAssignGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailType} notificationType 
     * @param {NotificationAssignRolesInput} [notificationAssignRolesInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationAssignApi
     */
    public apiNotiAssignNotificationTypeRolesPut(notificationType: EmailType, notificationAssignRolesInput?: NotificationAssignRolesInput, options?: AxiosRequestConfig) {
        return NotificationAssignApiFp(this.configuration).apiNotiAssignNotificationTypeRolesPut(notificationType, notificationAssignRolesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailType} notificationType 
     * @param {Array<number>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationAssignApi
     */
    public apiNotiAssignNotificationTypeUsersPut(notificationType: EmailType, requestBody?: Array<number>, options?: AxiosRequestConfig) {
        return NotificationAssignApiFp(this.configuration).apiNotiAssignNotificationTypeUsersPut(notificationType, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OptionsApi - axios parameter creator
 * @export
 */
export const OptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsGet: async (type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OptionsApi - functional programming interface
 * @export
 */
export const OptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOptionsGet(type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOptionsGet(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OptionsApi - factory interface
 * @export
 */
export const OptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionsGet(type?: string, options?: any): AxiosPromise<Array<OptionResponseDto>> {
            return localVarFp.apiOptionsGet(type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OptionsApi - object-oriented interface
 * @export
 * @class OptionsApi
 * @extends {BaseAPI}
 */
export class OptionsApi extends BaseAPI {
    /**
     * 
     * @param {string} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public apiOptionsGet(type?: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).apiOptionsGet(type, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsPermissionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsProfileGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OrganizationProfileInput} [organizationProfileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsProfilePost: async (organizationProfileInput?: OrganizationProfileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationProfileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiOrganizationsRolesIdDelete', 'id', id)
            const localVarPath = `/api/organizations/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [isDefault] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesIdGet: async (id: number, isDefault?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiOrganizationsRolesIdGet', 'id', id)
            const localVarPath = `/api/organizations/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isDefault !== undefined) {
                localVarQueryParameter['isDefault'] = isDefault;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RoleInput} [roleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesIdPut: async (id: number, roleInput?: RoleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiOrganizationsRolesIdPut', 'id', id)
            const localVarPath = `/api/organizations/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RoleInput} [roleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesPost: async (roleInput?: RoleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StorageFirewallIpInput} [storageFirewallIpInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsStoragefirewallDelete: async (storageFirewallIpInput?: StorageFirewallIpInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/storagefirewall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storageFirewallIpInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsStoragefirewallGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/storagefirewall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StorageFirewallIpInput} [storageFirewallIpInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsStoragefirewallPost: async (storageFirewallIpInput?: StorageFirewallIpInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/storagefirewall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storageFirewallIpInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsPermissionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsPermissionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsProfileGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsProfileGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OrganizationProfileInput} [organizationProfileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsProfilePost(organizationProfileInput?: OrganizationProfileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsProfilePost(organizationProfileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsRolesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsRolesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsRolesIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsRolesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [isDefault] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsRolesIdGet(id: number, isDefault?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsRolesIdGet(id, isDefault, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {RoleInput} [roleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsRolesIdPut(id: number, roleInput?: RoleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsRolesIdPut(id, roleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RoleInput} [roleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsRolesPost(roleInput?: RoleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsRolesPost(roleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StorageFirewallIpInput} [storageFirewallIpInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsStoragefirewallDelete(storageFirewallIpInput?: StorageFirewallIpInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsStoragefirewallDelete(storageFirewallIpInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsStoragefirewallGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsStoragefirewallGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {StorageFirewallIpInput} [storageFirewallIpInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsStoragefirewallPost(storageFirewallIpInput?: StorageFirewallIpInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsStoragefirewallPost(storageFirewallIpInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsPermissionsGet(options?: any): AxiosPromise<Array<PermissionResponseDto>> {
            return localVarFp.apiOrganizationsPermissionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsProfileGet(options?: any): AxiosPromise<OrganizationProfileResponseDto> {
            return localVarFp.apiOrganizationsProfileGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrganizationProfileInput} [organizationProfileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsProfilePost(organizationProfileInput?: OrganizationProfileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiOrganizationsProfilePost(organizationProfileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesGet(options?: any): AxiosPromise<Array<RoleResponseDto>> {
            return localVarFp.apiOrganizationsRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiOrganizationsRolesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [isDefault] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesIdGet(id: number, isDefault?: boolean, options?: any): AxiosPromise<RoleResponseDto> {
            return localVarFp.apiOrganizationsRolesIdGet(id, isDefault, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RoleInput} [roleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesIdPut(id: number, roleInput?: RoleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiOrganizationsRolesIdPut(id, roleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RoleInput} [roleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsRolesPost(roleInput?: RoleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiOrganizationsRolesPost(roleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StorageFirewallIpInput} [storageFirewallIpInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsStoragefirewallDelete(storageFirewallIpInput?: StorageFirewallIpInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiOrganizationsStoragefirewallDelete(storageFirewallIpInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsStoragefirewallGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiOrganizationsStoragefirewallGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StorageFirewallIpInput} [storageFirewallIpInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsStoragefirewallPost(storageFirewallIpInput?: StorageFirewallIpInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiOrganizationsStoragefirewallPost(storageFirewallIpInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsPermissionsGet(options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsPermissionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsProfileGet(options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsProfileGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrganizationProfileInput} [organizationProfileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsProfilePost(organizationProfileInput?: OrganizationProfileInput, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsProfilePost(organizationProfileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsRolesGet(options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsRolesIdDelete(id: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsRolesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [isDefault] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsRolesIdGet(id: number, isDefault?: boolean, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsRolesIdGet(id, isDefault, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {RoleInput} [roleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsRolesIdPut(id: number, roleInput?: RoleInput, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsRolesIdPut(id, roleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RoleInput} [roleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsRolesPost(roleInput?: RoleInput, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsRolesPost(roleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StorageFirewallIpInput} [storageFirewallIpInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsStoragefirewallDelete(storageFirewallIpInput?: StorageFirewallIpInput, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsStoragefirewallDelete(storageFirewallIpInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsStoragefirewallGet(options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsStoragefirewallGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StorageFirewallIpInput} [storageFirewallIpInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsStoragefirewallPost(storageFirewallIpInput?: StorageFirewallIpInput, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsStoragefirewallPost(storageFirewallIpInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SsoApi - axios parameter creator
 * @export
 */
export const SsoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoConfigGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sso/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isEnabled] 
         * @param {SsoProtocol} [protocol] 
         * @param {string} [samlLoginUrl] 
         * @param {string} [samlLogoutUrl] 
         * @param {string} [samlEntityId] 
         * @param {any} [samlCertificateFile] 
         * @param {string} [oidcDomain] 
         * @param {string} [oidcClientId] 
         * @param {string} [oidcClientSecret] 
         * @param {string} [oidcLogoutUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoConfigPost: async (isEnabled?: boolean, protocol?: SsoProtocol, samlLoginUrl?: string, samlLogoutUrl?: string, samlEntityId?: string, samlCertificateFile?: any, oidcDomain?: string, oidcClientId?: string, oidcClientSecret?: string, oidcLogoutUrl?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sso/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (isEnabled !== undefined) { 
                localVarFormParams.append('IsEnabled', isEnabled as any);
            }
    
            if (protocol !== undefined) { 
                localVarFormParams.append('Protocol', protocol as any);
            }
    
            if (samlLoginUrl !== undefined) { 
                localVarFormParams.append('SamlLoginUrl', samlLoginUrl as any);
            }
    
            if (samlLogoutUrl !== undefined) { 
                localVarFormParams.append('SamlLogoutUrl', samlLogoutUrl as any);
            }
    
            if (samlEntityId !== undefined) { 
                localVarFormParams.append('SamlEntityId', samlEntityId as any);
            }
    
            if (samlCertificateFile !== undefined) { 
                localVarFormParams.append('SamlCertificateFile', samlCertificateFile as any);
            }
    
            if (oidcDomain !== undefined) { 
                localVarFormParams.append('OidcDomain', oidcDomain as any);
            }
    
            if (oidcClientId !== undefined) { 
                localVarFormParams.append('OidcClientId', oidcClientId as any);
            }
    
            if (oidcClientSecret !== undefined) { 
                localVarFormParams.append('OidcClientSecret', oidcClientSecret as any);
            }
    
            if (oidcLogoutUrl !== undefined) { 
                localVarFormParams.append('OidcLogoutUrl', oidcLogoutUrl as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoConfigSamlcertGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sso/config/samlcert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoLogouturlPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sso/logouturl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} state 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoOidcConsumerPost: async (state: string, code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('apiSsoOidcConsumerPost', 'state', state)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiSsoOidcConsumerPost', 'code', code)
            const localVarPath = `/api/sso/oidc/consumer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (state !== undefined) { 
                localVarFormParams.append('State', state as any);
            }
    
            if (code !== undefined) { 
                localVarFormParams.append('Code', code as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SsoRequestInput} [ssoRequestInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoRedirecturlPost: async (ssoRequestInput?: SsoRequestInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sso/redirecturl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ssoRequestInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [relayState] 
         * @param {string} [sAMLResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoSamlConsumerPost: async (relayState?: string, sAMLResponse?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sso/saml/consumer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (relayState !== undefined) { 
                localVarFormParams.append('RelayState', relayState as any);
            }
    
            if (sAMLResponse !== undefined) { 
                localVarFormParams.append('SAMLResponse', sAMLResponse as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoSamlSloSigningCertGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sso/saml/slo/signingCert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SsoApi - functional programming interface
 * @export
 */
export const SsoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SsoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSsoConfigGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSsoConfigGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [isEnabled] 
         * @param {SsoProtocol} [protocol] 
         * @param {string} [samlLoginUrl] 
         * @param {string} [samlLogoutUrl] 
         * @param {string} [samlEntityId] 
         * @param {any} [samlCertificateFile] 
         * @param {string} [oidcDomain] 
         * @param {string} [oidcClientId] 
         * @param {string} [oidcClientSecret] 
         * @param {string} [oidcLogoutUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSsoConfigPost(isEnabled?: boolean, protocol?: SsoProtocol, samlLoginUrl?: string, samlLogoutUrl?: string, samlEntityId?: string, samlCertificateFile?: any, oidcDomain?: string, oidcClientId?: string, oidcClientSecret?: string, oidcLogoutUrl?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSsoConfigPost(isEnabled, protocol, samlLoginUrl, samlLogoutUrl, samlEntityId, samlCertificateFile, oidcDomain, oidcClientId, oidcClientSecret, oidcLogoutUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSsoConfigSamlcertGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSsoConfigSamlcertGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSsoLogouturlPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSsoLogouturlPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} state 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSsoOidcConsumerPost(state: string, code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSsoOidcConsumerPost(state, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SsoRequestInput} [ssoRequestInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSsoRedirecturlPost(ssoRequestInput?: SsoRequestInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSsoRedirecturlPost(ssoRequestInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [relayState] 
         * @param {string} [sAMLResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSsoSamlConsumerPost(relayState?: string, sAMLResponse?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSsoSamlConsumerPost(relayState, sAMLResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSsoSamlSloSigningCertGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSsoSamlSloSigningCertGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SsoApi - factory interface
 * @export
 */
export const SsoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SsoApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoConfigGet(options?: any): AxiosPromise<SsoConfigResponseDto> {
            return localVarFp.apiSsoConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [isEnabled] 
         * @param {SsoProtocol} [protocol] 
         * @param {string} [samlLoginUrl] 
         * @param {string} [samlLogoutUrl] 
         * @param {string} [samlEntityId] 
         * @param {any} [samlCertificateFile] 
         * @param {string} [oidcDomain] 
         * @param {string} [oidcClientId] 
         * @param {string} [oidcClientSecret] 
         * @param {string} [oidcLogoutUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoConfigPost(isEnabled?: boolean, protocol?: SsoProtocol, samlLoginUrl?: string, samlLogoutUrl?: string, samlEntityId?: string, samlCertificateFile?: any, oidcDomain?: string, oidcClientId?: string, oidcClientSecret?: string, oidcLogoutUrl?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiSsoConfigPost(isEnabled, protocol, samlLoginUrl, samlLogoutUrl, samlEntityId, samlCertificateFile, oidcDomain, oidcClientId, oidcClientSecret, oidcLogoutUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoConfigSamlcertGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiSsoConfigSamlcertGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoLogouturlPost(options?: any): AxiosPromise<string> {
            return localVarFp.apiSsoLogouturlPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} state 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoOidcConsumerPost(state: string, code: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiSsoOidcConsumerPost(state, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SsoRequestInput} [ssoRequestInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoRedirecturlPost(ssoRequestInput?: SsoRequestInput, options?: any): AxiosPromise<string> {
            return localVarFp.apiSsoRedirecturlPost(ssoRequestInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [relayState] 
         * @param {string} [sAMLResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoSamlConsumerPost(relayState?: string, sAMLResponse?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiSsoSamlConsumerPost(relayState, sAMLResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSsoSamlSloSigningCertGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiSsoSamlSloSigningCertGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SsoApi - object-oriented interface
 * @export
 * @class SsoApi
 * @extends {BaseAPI}
 */
export class SsoApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public apiSsoConfigGet(options?: AxiosRequestConfig) {
        return SsoApiFp(this.configuration).apiSsoConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [isEnabled] 
     * @param {SsoProtocol} [protocol] 
     * @param {string} [samlLoginUrl] 
     * @param {string} [samlLogoutUrl] 
     * @param {string} [samlEntityId] 
     * @param {any} [samlCertificateFile] 
     * @param {string} [oidcDomain] 
     * @param {string} [oidcClientId] 
     * @param {string} [oidcClientSecret] 
     * @param {string} [oidcLogoutUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public apiSsoConfigPost(isEnabled?: boolean, protocol?: SsoProtocol, samlLoginUrl?: string, samlLogoutUrl?: string, samlEntityId?: string, samlCertificateFile?: any, oidcDomain?: string, oidcClientId?: string, oidcClientSecret?: string, oidcLogoutUrl?: string, options?: AxiosRequestConfig) {
        return SsoApiFp(this.configuration).apiSsoConfigPost(isEnabled, protocol, samlLoginUrl, samlLogoutUrl, samlEntityId, samlCertificateFile, oidcDomain, oidcClientId, oidcClientSecret, oidcLogoutUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public apiSsoConfigSamlcertGet(options?: AxiosRequestConfig) {
        return SsoApiFp(this.configuration).apiSsoConfigSamlcertGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public apiSsoLogouturlPost(options?: AxiosRequestConfig) {
        return SsoApiFp(this.configuration).apiSsoLogouturlPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} state 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public apiSsoOidcConsumerPost(state: string, code: string, options?: AxiosRequestConfig) {
        return SsoApiFp(this.configuration).apiSsoOidcConsumerPost(state, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SsoRequestInput} [ssoRequestInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public apiSsoRedirecturlPost(ssoRequestInput?: SsoRequestInput, options?: AxiosRequestConfig) {
        return SsoApiFp(this.configuration).apiSsoRedirecturlPost(ssoRequestInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [relayState] 
     * @param {string} [sAMLResponse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public apiSsoSamlConsumerPost(relayState?: string, sAMLResponse?: string, options?: AxiosRequestConfig) {
        return SsoApiFp(this.configuration).apiSsoSamlConsumerPost(relayState, sAMLResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public apiSsoSamlSloSigningCertGet(options?: AxiosRequestConfig) {
        return SsoApiFp(this.configuration).apiSsoSamlSloSigningCertGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAdmininviteConfirmPost: async (initPasswordConfirmInput?: InitPasswordConfirmInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/admininvite/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initPasswordConfirmInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAdmininviteValidatePost: async (emailValidateInput?: EmailValidateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/admininvite/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailValidateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdDelete', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdGet', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUserInput} [updateUserInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut: async (id: number, updateUserInput?: UpdateUserInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersIdPut', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfirmUserInvitationInput} [confirmUserInvitationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInviteConfirmPost: async (confirmUserInvitationInput?: ConfirmUserInvitationInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/invite/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmUserInvitationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInviteIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUsersInviteIdDelete', 'id', id)
            const localVarPath = `/api/users/invite/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InviteUserInput} [inviteUserInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitePost: async (inviteUserInput?: InviteUserInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserInvitationSearchCriterias} [userInvitationSearchCriterias] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInviteSearchPost: async (userInvitationSearchCriterias?: UserInvitationSearchCriterias, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/invite/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userInvitationSearchCriterias, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInviteValidatePost: async (emailValidateInput?: EmailValidateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/invite/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailValidateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginInput} [loginInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersLoginPost: async (loginInput?: LoginInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersOptionsGet: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserSearchCriterias} [userSearchCriterias] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPost: async (userSearchCriterias?: UserSearchCriterias, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSearchCriterias, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileEmailConfirmPost: async (emailValidateInput?: EmailValidateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/profile/email/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailValidateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailInput} [emailInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileEmailPut: async (emailInput?: EmailInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/profile/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} phone 
         * @param {string} phoneVerifyCode 
         * @param {string} language 
         * @param {string} timeZoneName 
         * @param {any} [avatarFile] 
         * @param {number} [phoneVerifyCodeId] 
         * @param {MfaWay} [mfaWay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileNewPost: async (firstName: string, lastName: string, phone: string, phoneVerifyCode: string, language: string, timeZoneName: string, avatarFile?: any, phoneVerifyCodeId?: number, mfaWay?: MfaWay, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firstName' is not null or undefined
            assertParamExists('apiUsersProfileNewPost', 'firstName', firstName)
            // verify required parameter 'lastName' is not null or undefined
            assertParamExists('apiUsersProfileNewPost', 'lastName', lastName)
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('apiUsersProfileNewPost', 'phone', phone)
            // verify required parameter 'phoneVerifyCode' is not null or undefined
            assertParamExists('apiUsersProfileNewPost', 'phoneVerifyCode', phoneVerifyCode)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiUsersProfileNewPost', 'language', language)
            // verify required parameter 'timeZoneName' is not null or undefined
            assertParamExists('apiUsersProfileNewPost', 'timeZoneName', timeZoneName)
            const localVarPath = `/api/users/profile/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (firstName !== undefined) { 
                localVarFormParams.append('FirstName', firstName as any);
            }
    
            if (lastName !== undefined) { 
                localVarFormParams.append('LastName', lastName as any);
            }
    
            if (phone !== undefined) { 
                localVarFormParams.append('Phone', phone as any);
            }
    
            if (phoneVerifyCode !== undefined) { 
                localVarFormParams.append('PhoneVerifyCode', phoneVerifyCode as any);
            }
    
            if (avatarFile !== undefined) { 
                localVarFormParams.append('AvatarFile', avatarFile as any);
            }
    
            if (phoneVerifyCodeId !== undefined) { 
                localVarFormParams.append('PhoneVerifyCodeId', phoneVerifyCodeId as any);
            }
    
            if (mfaWay !== undefined) { 
                localVarFormParams.append('MfaWay', mfaWay as any);
            }
    
            if (language !== undefined) { 
                localVarFormParams.append('Language', language as any);
            }
    
            if (timeZoneName !== undefined) { 
                localVarFormParams.append('TimeZoneName', timeZoneName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangePasswordInput} [changePasswordInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfilePasswordPut: async (changePasswordInput?: ChangePasswordInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/profile/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfirmChangePhoneInput} [confirmChangePhoneInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfilePhoneConfirmPost: async (confirmChangePhoneInput?: ConfirmChangePhoneInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/profile/phone/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmChangePhoneInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangePhoneInput} [changePhoneInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfilePhonePut: async (changePhoneInput?: ChangePhoneInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/profile/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePhoneInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} language 
         * @param {string} timeZoneName 
         * @param {MfaWay} [mfaWay] 
         * @param {any} [avatarFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileUpdatePost: async (firstName: string, lastName: string, language: string, timeZoneName: string, mfaWay?: MfaWay, avatarFile?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firstName' is not null or undefined
            assertParamExists('apiUsersProfileUpdatePost', 'firstName', firstName)
            // verify required parameter 'lastName' is not null or undefined
            assertParamExists('apiUsersProfileUpdatePost', 'lastName', lastName)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiUsersProfileUpdatePost', 'language', language)
            // verify required parameter 'timeZoneName' is not null or undefined
            assertParamExists('apiUsersProfileUpdatePost', 'timeZoneName', timeZoneName)
            const localVarPath = `/api/users/profile/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (firstName !== undefined) { 
                localVarFormParams.append('FirstName', firstName as any);
            }
    
            if (lastName !== undefined) { 
                localVarFormParams.append('LastName', lastName as any);
            }
    
            if (mfaWay !== undefined) { 
                localVarFormParams.append('MfaWay', mfaWay as any);
            }
    
            if (avatarFile !== undefined) { 
                localVarFormParams.append('AvatarFile', avatarFile as any);
            }
    
            if (language !== undefined) { 
                localVarFormParams.append('Language', language as any);
            }
    
            if (timeZoneName !== undefined) { 
                localVarFormParams.append('TimeZoneName', timeZoneName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRegisterConfirmPost: async (initPasswordConfirmInput?: InitPasswordConfirmInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/register/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initPasswordConfirmInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterInput} [registerInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRegisterPost: async (registerInput?: RegisterInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRegisterValidatePost: async (emailValidateInput?: EmailValidateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/register/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailValidateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersResetpasswordConfirmPost: async (initPasswordConfirmInput?: InitPasswordConfirmInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/resetpassword/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initPasswordConfirmInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordInput} [resetPasswordInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersResetpasswordPost: async (resetPasswordInput?: ResetPasswordInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/resetpassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersResetpasswordValidatePost: async (emailValidateInput?: EmailValidateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/resetpassword/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailValidateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersAdmininviteConfirmPost(initPasswordConfirmInput?: InitPasswordConfirmInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersAdmininviteConfirmPost(initPasswordConfirmInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersAdmininviteValidatePost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInvitationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersAdmininviteValidatePost(emailValidateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUserInput} [updateUserInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersIdPut(id: number, updateUserInput?: UpdateUserInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersIdPut(id, updateUserInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ConfirmUserInvitationInput} [confirmUserInvitationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersInviteConfirmPost(confirmUserInvitationInput?: ConfirmUserInvitationInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersInviteConfirmPost(confirmUserInvitationInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersInviteIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersInviteIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InviteUserInput} [inviteUserInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersInvitePost(inviteUserInput?: InviteUserInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersInvitePost(inviteUserInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserInvitationSearchCriterias} [userInvitationSearchCriterias] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersInviteSearchPost(userInvitationSearchCriterias?: UserInvitationSearchCriterias, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInvitationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersInviteSearchPost(userInvitationSearchCriterias, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersInviteValidatePost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInvitationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersInviteValidatePost(emailValidateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoginInput} [loginInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersLoginPost(loginInput?: LoginInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersLoginPost(loginInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersOptionsGet(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOptionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersOptionsGet(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserSearchCriterias} [userSearchCriterias] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersPost(userSearchCriterias?: UserSearchCriterias, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersPost(userSearchCriterias, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfileEmailConfirmPost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfileEmailConfirmPost(emailValidateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailInput} [emailInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfileEmailPut(emailInput?: EmailInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfileEmailPut(emailInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfileGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfileGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} phone 
         * @param {string} phoneVerifyCode 
         * @param {string} language 
         * @param {string} timeZoneName 
         * @param {any} [avatarFile] 
         * @param {number} [phoneVerifyCodeId] 
         * @param {MfaWay} [mfaWay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfileNewPost(firstName: string, lastName: string, phone: string, phoneVerifyCode: string, language: string, timeZoneName: string, avatarFile?: any, phoneVerifyCodeId?: number, mfaWay?: MfaWay, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfileNewPost(firstName, lastName, phone, phoneVerifyCode, language, timeZoneName, avatarFile, phoneVerifyCodeId, mfaWay, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ChangePasswordInput} [changePasswordInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfilePasswordPut(changePasswordInput?: ChangePasswordInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfilePasswordPut(changePasswordInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ConfirmChangePhoneInput} [confirmChangePhoneInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfilePhoneConfirmPost(confirmChangePhoneInput?: ConfirmChangePhoneInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfilePhoneConfirmPost(confirmChangePhoneInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ChangePhoneInput} [changePhoneInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfilePhonePut(changePhoneInput?: ChangePhoneInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangePhoneResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfilePhonePut(changePhoneInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} language 
         * @param {string} timeZoneName 
         * @param {MfaWay} [mfaWay] 
         * @param {any} [avatarFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersProfileUpdatePost(firstName: string, lastName: string, language: string, timeZoneName: string, mfaWay?: MfaWay, avatarFile?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersProfileUpdatePost(firstName, lastName, language, timeZoneName, mfaWay, avatarFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersRegisterConfirmPost(initPasswordConfirmInput?: InitPasswordConfirmInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersRegisterConfirmPost(initPasswordConfirmInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegisterInput} [registerInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersRegisterPost(registerInput?: RegisterInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersRegisterPost(registerInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersRegisterValidatePost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersRegisterValidatePost(emailValidateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersResetpasswordConfirmPost(initPasswordConfirmInput?: InitPasswordConfirmInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersResetpasswordConfirmPost(initPasswordConfirmInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResetPasswordInput} [resetPasswordInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersResetpasswordPost(resetPasswordInput?: ResetPasswordInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersResetpasswordPost(resetPasswordInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersResetpasswordValidatePost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersResetpasswordValidatePost(emailValidateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAdmininviteConfirmPost(initPasswordConfirmInput?: InitPasswordConfirmInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersAdmininviteConfirmPost(initPasswordConfirmInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersAdmininviteValidatePost(emailValidateInput?: EmailValidateInput, options?: any): AxiosPromise<AdminInvitationResponseDto> {
            return localVarFp.apiUsersAdmininviteValidatePost(emailValidateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdGet(id: number, options?: any): AxiosPromise<UserResponseDto> {
            return localVarFp.apiUsersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUserInput} [updateUserInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersIdPut(id: number, updateUserInput?: UpdateUserInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersIdPut(id, updateUserInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfirmUserInvitationInput} [confirmUserInvitationInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInviteConfirmPost(confirmUserInvitationInput?: ConfirmUserInvitationInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersInviteConfirmPost(confirmUserInvitationInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInviteIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersInviteIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InviteUserInput} [inviteUserInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInvitePost(inviteUserInput?: InviteUserInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersInvitePost(inviteUserInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserInvitationSearchCriterias} [userInvitationSearchCriterias] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInviteSearchPost(userInvitationSearchCriterias?: UserInvitationSearchCriterias, options?: any): AxiosPromise<UserInvitationsResponseDto> {
            return localVarFp.apiUsersInviteSearchPost(userInvitationSearchCriterias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersInviteValidatePost(emailValidateInput?: EmailValidateInput, options?: any): AxiosPromise<UserInvitationResponseDto> {
            return localVarFp.apiUsersInviteValidatePost(emailValidateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginInput} [loginInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersLoginPost(loginInput?: LoginInput, options?: any): AxiosPromise<LoginResponseDto> {
            return localVarFp.apiUsersLoginPost(loginInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersOptionsGet(page?: number, limit?: number, options?: any): AxiosPromise<UserOptionsResponseDto> {
            return localVarFp.apiUsersOptionsGet(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserSearchCriterias} [userSearchCriterias] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPost(userSearchCriterias?: UserSearchCriterias, options?: any): AxiosPromise<UsersResponseDto> {
            return localVarFp.apiUsersPost(userSearchCriterias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileEmailConfirmPost(emailValidateInput?: EmailValidateInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersProfileEmailConfirmPost(emailValidateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailInput} [emailInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileEmailPut(emailInput?: EmailInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersProfileEmailPut(emailInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileGet(options?: any): AxiosPromise<UserResponseDto> {
            return localVarFp.apiUsersProfileGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} phone 
         * @param {string} phoneVerifyCode 
         * @param {string} language 
         * @param {string} timeZoneName 
         * @param {any} [avatarFile] 
         * @param {number} [phoneVerifyCodeId] 
         * @param {MfaWay} [mfaWay] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileNewPost(firstName: string, lastName: string, phone: string, phoneVerifyCode: string, language: string, timeZoneName: string, avatarFile?: any, phoneVerifyCodeId?: number, mfaWay?: MfaWay, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersProfileNewPost(firstName, lastName, phone, phoneVerifyCode, language, timeZoneName, avatarFile, phoneVerifyCodeId, mfaWay, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChangePasswordInput} [changePasswordInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfilePasswordPut(changePasswordInput?: ChangePasswordInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersProfilePasswordPut(changePasswordInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfirmChangePhoneInput} [confirmChangePhoneInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfilePhoneConfirmPost(confirmChangePhoneInput?: ConfirmChangePhoneInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersProfilePhoneConfirmPost(confirmChangePhoneInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChangePhoneInput} [changePhoneInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfilePhonePut(changePhoneInput?: ChangePhoneInput, options?: any): AxiosPromise<ChangePhoneResponseDto> {
            return localVarFp.apiUsersProfilePhonePut(changePhoneInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} language 
         * @param {string} timeZoneName 
         * @param {MfaWay} [mfaWay] 
         * @param {any} [avatarFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersProfileUpdatePost(firstName: string, lastName: string, language: string, timeZoneName: string, mfaWay?: MfaWay, avatarFile?: any, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersProfileUpdatePost(firstName, lastName, language, timeZoneName, mfaWay, avatarFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRegisterConfirmPost(initPasswordConfirmInput?: InitPasswordConfirmInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersRegisterConfirmPost(initPasswordConfirmInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterInput} [registerInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRegisterPost(registerInput?: RegisterInput, options?: any): AxiosPromise<RegisterResultResponseDto> {
            return localVarFp.apiUsersRegisterPost(registerInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRegisterValidatePost(emailValidateInput?: EmailValidateInput, options?: any): AxiosPromise<RegisterResponseDto> {
            return localVarFp.apiUsersRegisterValidatePost(emailValidateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersResetpasswordConfirmPost(initPasswordConfirmInput?: InitPasswordConfirmInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersResetpasswordConfirmPost(initPasswordConfirmInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResetPasswordInput} [resetPasswordInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersResetpasswordPost(resetPasswordInput?: ResetPasswordInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiUsersResetpasswordPost(resetPasswordInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailValidateInput} [emailValidateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersResetpasswordValidatePost(emailValidateInput?: EmailValidateInput, options?: any): AxiosPromise<ResetPasswordResponseDto> {
            return localVarFp.apiUsersResetpasswordValidatePost(emailValidateInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersAdmininviteConfirmPost(initPasswordConfirmInput?: InitPasswordConfirmInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersAdmininviteConfirmPost(initPasswordConfirmInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailValidateInput} [emailValidateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersAdmininviteValidatePost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersAdmininviteValidatePost(emailValidateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersIdDelete(id: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersIdGet(id: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateUserInput} [updateUserInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersIdPut(id: number, updateUserInput?: UpdateUserInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersIdPut(id, updateUserInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfirmUserInvitationInput} [confirmUserInvitationInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersInviteConfirmPost(confirmUserInvitationInput?: ConfirmUserInvitationInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersInviteConfirmPost(confirmUserInvitationInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersInviteIdDelete(id: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersInviteIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InviteUserInput} [inviteUserInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersInvitePost(inviteUserInput?: InviteUserInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersInvitePost(inviteUserInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserInvitationSearchCriterias} [userInvitationSearchCriterias] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersInviteSearchPost(userInvitationSearchCriterias?: UserInvitationSearchCriterias, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersInviteSearchPost(userInvitationSearchCriterias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailValidateInput} [emailValidateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersInviteValidatePost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersInviteValidatePost(emailValidateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginInput} [loginInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersLoginPost(loginInput?: LoginInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersLoginPost(loginInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersOptionsGet(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersOptionsGet(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserSearchCriterias} [userSearchCriterias] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersPost(userSearchCriterias?: UserSearchCriterias, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersPost(userSearchCriterias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailValidateInput} [emailValidateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersProfileEmailConfirmPost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfileEmailConfirmPost(emailValidateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailInput} [emailInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersProfileEmailPut(emailInput?: EmailInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfileEmailPut(emailInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersProfileGet(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfileGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} firstName 
     * @param {string} lastName 
     * @param {string} phone 
     * @param {string} phoneVerifyCode 
     * @param {string} language 
     * @param {string} timeZoneName 
     * @param {any} [avatarFile] 
     * @param {number} [phoneVerifyCodeId] 
     * @param {MfaWay} [mfaWay] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersProfileNewPost(firstName: string, lastName: string, phone: string, phoneVerifyCode: string, language: string, timeZoneName: string, avatarFile?: any, phoneVerifyCodeId?: number, mfaWay?: MfaWay, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfileNewPost(firstName, lastName, phone, phoneVerifyCode, language, timeZoneName, avatarFile, phoneVerifyCodeId, mfaWay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChangePasswordInput} [changePasswordInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersProfilePasswordPut(changePasswordInput?: ChangePasswordInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfilePasswordPut(changePasswordInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfirmChangePhoneInput} [confirmChangePhoneInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersProfilePhoneConfirmPost(confirmChangePhoneInput?: ConfirmChangePhoneInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfilePhoneConfirmPost(confirmChangePhoneInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChangePhoneInput} [changePhoneInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersProfilePhonePut(changePhoneInput?: ChangePhoneInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfilePhonePut(changePhoneInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} firstName 
     * @param {string} lastName 
     * @param {string} language 
     * @param {string} timeZoneName 
     * @param {MfaWay} [mfaWay] 
     * @param {any} [avatarFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersProfileUpdatePost(firstName: string, lastName: string, language: string, timeZoneName: string, mfaWay?: MfaWay, avatarFile?: any, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersProfileUpdatePost(firstName, lastName, language, timeZoneName, mfaWay, avatarFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersRegisterConfirmPost(initPasswordConfirmInput?: InitPasswordConfirmInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersRegisterConfirmPost(initPasswordConfirmInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterInput} [registerInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersRegisterPost(registerInput?: RegisterInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersRegisterPost(registerInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailValidateInput} [emailValidateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersRegisterValidatePost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersRegisterValidatePost(emailValidateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InitPasswordConfirmInput} [initPasswordConfirmInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersResetpasswordConfirmPost(initPasswordConfirmInput?: InitPasswordConfirmInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersResetpasswordConfirmPost(initPasswordConfirmInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResetPasswordInput} [resetPasswordInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersResetpasswordPost(resetPasswordInput?: ResetPasswordInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersResetpasswordPost(resetPasswordInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailValidateInput} [emailValidateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiUsersResetpasswordValidatePost(emailValidateInput?: EmailValidateInput, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiUsersResetpasswordValidatePost(emailValidateInput, options).then((request) => request(this.axios, this.basePath));
    }
}


